import {Component} from '@wonderlandengine/api';
import {WLUtils} from '../../utils/WLUtils.js';

export class SendMessageOnClick {
    target?: Component;
    functionName: string;

    target2?: Component;
    functionName2: string;

    onClick() {
        if (this.target != null) {
            WLUtils.sendMessage(this.target.object, this.functionName, undefined, false);
        }
        if (this.target2 != null) {
            WLUtils.sendMessage(this.target2.object, this.functionName2, undefined, false);
        }
    }
}
